module.exports = __webpack_public_path__ + "img/img-6.9e219cf8.webp";